<template>
  <div class="topic-progress">
    <span v-if="topicProgressCompleted === topicContentLength">
      <GreenTickIcon />
    </span>
    <RadialProgressBar
      v-else
      :diameter="30"
      :strokeWidth="3"
      innerStrokeColor="#444444"
      startColor="#70FFD4"
      stopColor="#70FFD4"
      :completed-steps="topicProgressCompleted"
      :total-steps="topicContentLength"
    />
    <p class="topic-progress__progress-count">
      {{ progressText }}
    </p>
  </div>
</template>
<script>
import RadialProgressBar from 'vue-radial-progress'
import GreenTickIcon from '@/assets/icons/course/green_tick.svg'

export default {
  name: 'TopicProgress',
  components: {
    RadialProgressBar,
    GreenTickIcon,
  },
  props: {
    topicProgressCompleted: {
      type: Number,
      required: true,
    },
    topicContentLength: {
      type: Number,
      reuqired: true,
    },
  },
  computed: {
    progressText() {
      return this.topicProgressCompleted === this.topicContentLength
        ? 'Section finished'
        : `${this.topicProgressCompleted}/${this.topicContentLength}  items finished`
    },
  },
}
</script>
<style lang="scss" scoped>
.topic-progress {
  display: flex;
  position: relative;
  margin: 20px 0px;
  flex-grow: 1;
  background-color: var(--glass-mid-gray);

  @include tablet {
    margin-top: 30px;
  }

  /* Body II */
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */

  display: flex;
  align-items: center;

  /* Primary/INE White */

  color: #ffffff;
  &__centered {
    justify-content: center;
  }
  &__completed {
    color: var(--black);
    background-color: var(--green);
    border-radius: 100%;
    font-size: 1.5rem;
    padding: 2px;
  }
  &__progress-count {
    margin-left: 10px;
    margin-bottom: 0px;
    font-size: 14px;
    padding: 3px;
    white-space: nowrap;
  }
}
</style>
